import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import SupportTypeComponent from "../../components/applicationComponents/supportType/supportType";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";

export default function SupportTypePage() {
  const [id, setId] = useState("");
  const [searchParams] = useSearchParams();
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    const idParam = searchParams.get("id");
    setId(idParam ?? "");
    setHeaderText({
      value: "Type of Support",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <SupportTypeComponent disabled={false} id={id} />
    </>
  );
}
